/* ==========================================
   SnS Collection Randomizer (SNSCR)
   - Modes: off | on_load | by_days
   - Fixed products first (metafield handles list)
   - No flash: uses data-snscr-ready (server sets false, JS sets true)
   - Works after Dawn re-renders the grid (MutationObserver)
   ========================================== */

(function () {
  "use strict";

  // ---------- Helpers ----------
  function isLikelyBot() {
    const ua = (navigator.userAgent || "").toLowerCase();
    return /bot|crawl|spider|slurp|bingpreview|duckduckbot|yandex|baidu|facebookexternalhit|twitterbot|pinterest|linkedinbot|embedly|quora|whatsapp|telegrambot/.test(
      ua
    );
  }

  function mulberry32(seed) {
    return function () {
      let t = (seed += 0x6d2b79f5);
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function shuffleInPlace(arr, rng) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(rng() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  function stableSeedFromString(str) {
    let h = 2166136261;
    for (let i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return (h >>> 0) || 1;
  }

  function getDayBucket(days) {
    const ms = 24 * 60 * 60 * 1000;
    return Math.floor(Date.now() / (days * ms));
  }

  function getGridAndCfg() {
    const grid = document.getElementById("product-grid");
    if (!grid) return null;

    // config can be on the grid itself (your case) or any parent
    const cfgEl = grid.closest("[data-snscr-config]") || grid;
    if (!cfgEl || !cfgEl.hasAttribute("data-snscr-config")) return null;

    return { grid, cfgEl };
  }

  function runOnce() {
    const ctx = getGridAndCfg();
    if (!ctx) return;

    const { grid, cfgEl } = ctx;

    // bots: do not randomize, but do NOT leave hidden
    if (isLikelyBot()) {
      grid.setAttribute("data-snscr-ready", "true");
      return;
    }

    const enabled = cfgEl.getAttribute("data-enabled") === "true";
    const mode = (cfgEl.getAttribute("data-mode") || "off").trim();

    if (!enabled || mode === "off") {
      grid.setAttribute("data-snscr-ready", "true");
      return;
    }

    const collectionHandle = (cfgEl.getAttribute("data-collection-handle") || "").trim();
    if (!collectionHandle) {
      grid.setAttribute("data-snscr-ready", "true");
      return;
    }

    // Hide while we reorder (prevents flash even after AJAX re-render)
    grid.setAttribute("data-snscr-ready", "false");

    try {
      const daysStr = cfgEl.getAttribute("data-days") || "7";
      const days = Math.max(1, Math.min(180, parseInt(daysStr, 10) || 7));
      const respectFixed = cfgEl.getAttribute("data-respect-fixed") === "true";

      const fixedRaw = (cfgEl.getAttribute("data-fixed") || "").trim();
      const fixedList = fixedRaw
        ? fixedRaw.split("|").map((s) => s.trim()).filter(Boolean)
        : [];

      const items = Array.from(grid.children).filter((el) => el && el.nodeType === 1);
      if (items.length < 2) {
        grid.setAttribute("data-snscr-ready", "true");
        return;
      }

      const byHandle = new Map();
      for (const el of items) {
        const h = el.getAttribute("data-product-handle");
        if (h) byHandle.set(h, el);
      }

      const fixedEls = [];
      const fixedUsed = new Set();

      if (respectFixed && fixedList.length && byHandle.size) {
        for (const h of fixedList) {
          const el = byHandle.get(h);
          if (el && !fixedUsed.has(el)) {
            fixedEls.push(el);
            fixedUsed.add(el);
          }
        }
      }

      const rest = items.filter((el) => !fixedUsed.has(el));

      let seedBase = "snscr:" + collectionHandle + ":";
      if (mode === "by_days") {
        seedBase += "bucket:" + String(getDayBucket(days));
      } else {
        seedBase += "load:" + String(Math.floor(Math.random() * 1e9));
      }

      const seed = stableSeedFromString(seedBase);
      const rng = mulberry32(seed);

      shuffleInPlace(rest, rng);

      const finalOrder = fixedEls.concat(rest);
      const frag = document.createDocumentFragment();
      for (const el of finalOrder) frag.appendChild(el);
      grid.appendChild(frag);

      // Show AFTER reorder
      grid.setAttribute("data-snscr-ready", "true");
    } catch (e) {
      // Never leave hidden
      grid.setAttribute("data-snscr-ready", "true");
    }
  }

  // Run on initial load
  document.addEventListener("DOMContentLoaded", function () {
    runOnce();

    // Also re-run if Dawn replaces the grid (filters/sorting/AJAX)
    const container = document.getElementById("ProductGridContainer") || document.body;
    const mo = new MutationObserver(function () {
      // If a new grid arrives, it will have data-snscr-ready="false" from Liquid
      // We reorder and then set it to true.
      const grid = document.getElementById("product-grid");
      if (grid && grid.getAttribute("data-snscr-ready") === "false") {
        runOnce();
      }
    });

    mo.observe(container, { childList: true, subtree: true });
  });
})();
